module.exports = __webpack_public_path__ + "img/soon.a7dee4d9.svg";